export default function DS_DataFrame() {
  return <div>DS_DataFrame Component</div>;
}
